import AbstractListView from '@UI/Store/AbstractListView';
import type FacilityUserView from '@UI/Store/FacilityUsers/Views/FacilityUserView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class FacilityUsersListView extends AbstractListView<FacilityUserView> {
	readonly facilityId: number;

	constructor(list: readonly FacilityUserView[], facilityId: number) {
		super(list, 'FacilityUsersListView');

		this.facilityId = facilityId;

		Object.freeze(this);
	}
}

export default FacilityUsersListView;
